<div class="grid">
    @if (loading && !sessions.length) {
    @for (i of skeletons; track i) {
    <div class="col-12 md:col-6">
        <p-skeleton height="3.5rem" class="border-round w-full"></p-skeleton>
    </div>
    }
    } @else {
    @for (session of sessions; track session.sid) {
    <div class="col-12 md:col-6">
        <div class="flex align-items-center gap-2 p-3 border-1 border-round-xl border-200 cursor-pointer h-full surface-0 hover:bg-blue-50 shadow-1 hover:shadow-2 transition-shadow duration-200"
            (click)="onClickOpen(session)">
            <!-- Avatar du propriétaire si la session le porte (supervision §9.1), sinon icône de conversation -->
            @if (session.user) {
            <app-avatar [user]="session.user"></app-avatar>
            } @else {
            <i class="pi pi-comment text-color-secondary"></i>
            }
            <div class="flex-1 overflow-hidden">
                <div class="text-sm text-color white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ session.title }}</div>
                @if (session.user) {
                <div class="text-xs text-color-secondary white-space-nowrap overflow-hidden text-overflow-ellipsis">{{ session.user.fullName }}</div>
                }
            </div>
            <p-button icon="pi pi-ellipsis-h" [text]="true" [rounded]="true" size="small"
                (onClick)="onClickMenu($event, session, convMenu); $event.stopPropagation()"></p-button>
        </div>
    </div>
    }
    }
</div>

<p-menu #convMenu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
